import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M6,18.584c1.569,-1.525 3.692,-2.463 6.023,-2.463c2.308,0 4.408,0.919 5.977,2.416c-1.569,1.525 -3.692,2.463 -6.023,2.463c-2.308,0 -4.408,-0.919 -5.977,-2.416Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M3.975,16.025c-0.61,-1.214 -0.975,-2.573 -0.975,-4.025c0,-4.974 4.026,-9 9,-9c4.974,0 9,4.026 9,9c0,1.45 -0.363,2.81 -0.977,4.023" }),
			/* @__PURE__ */ _jsx("path", { d: "M14.1213,7.87868c1.17157,1.17157 1.17157,3.07107 0,4.24264c-1.17157,1.17157 -3.07107,1.17157 -4.24264,0c-1.17157,-1.17157 -1.17157,-3.07107 0,-4.24264c1.17157,-1.17157 3.07107,-1.17157 4.24264,-8.88178e-16" })
		]
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0,0h24v24h-24Z"
	})]
});
export default SvgUser1;
